import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'findRoom'
})
export class FindRoomPipe implements PipeTransform {

    transform(rooms: any[], shard: string, room: string): string {
        if (!rooms || !shard || !rooms[shard] || !room) {
            return null;
        }

        return rooms[shard].find(({ room : roomName }) => roomName === room);
    }

}
